export default Object.freeze({
  Approved: 1,
  Rejected: 2,
  Signed: 3,
  TaskExecuted: 4,
  Saved: 5,
  Completed: 6,
  SavedAndCompleted: 7,
  ScheduledExecutionCompleted: 8,
  OverdueDateTimeReached: 9,
});
